<template lang="html">
  <div class="discount">

    <v-row>
      <v-col cols="12" sm="6">
        <v-checkbox
          label="Active"
          v-model="item.active"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-text-field
      label="Title"
      v-model="item.title"
      :rules="[required]"
    ></v-text-field>

    <v-textarea
      label="Description"
      v-model="item.description"
      auto-grow
      rows="1"
    ></v-textarea>

    <v-text-field
      label="Code"
      :value="item.code"
      @input="$set(item, 'code', ($event || '').trim().replace(/[^a-zA-Z0-9]/g, '').toUpperCase())"
      :rules="[required]"
      :type="showCode ? 'text' : 'password'"
    >
      <template #append>
        <v-btn icon @click="showCode = !showCode"><v-icon>{{showCode ? 'mdi-eye-off' : 'mdi-eye'}}</v-icon></v-btn>
      </template>
    </v-text-field>

    <v-row>
      <v-col cols="12" sm="6">
        <date-time-input-alt
          label="Valid from"
          v-model="item.start"
        ></date-time-input-alt>
      </v-col>
      <v-col cols="12" sm="6">
        <date-time-input-alt
          label="Valid to"
          v-model="item.end"
        ></date-time-input-alt>
      </v-col>
    </v-row>

    <v-text-field
      label="Max uses"
      v-model.number="item.count"
      type="number"
      hide-spin-buttons
    ></v-text-field>

    <v-select
      label="Discount type"
      v-model="item.discount_type"
      :items="discountTypes"
      @input="$set(item, 'details', {})"
      :rules="[required]"
    ></v-select>

    <div v-if="!item.discount_type">
      Select a discount type to continue
    </div>
    <div v-else>
      <div class="d-flex">
        <v-slider
          label="Percentage"
          v-model="item.details.percentage"
          max="100"
          min="5"
          :step="5"
          thumb-label
          track-color="grey"
          :rules="[required]"
        ></v-slider>
        <div class="pt-1" style="min-width: 50px; text-align: end;">
          {{item.details.percentage || 0}} %
        </div>
      </div>
    </div>

    <template v-if="!creating">
      <h2 class="my-4">Information</h2>

      <info-table
        :headers="headers"
        :value="item"
      ></info-table>

      <v-divider class="my-5" />

      <div class="">
        <h2 class="mb-4">Use Payments</h2>

        <div class="">
          <div v-if="!item.usePayments || item.usePayments.length == 0" class="">
            Discount has not been used yet
          </div>
          <div v-else>
            <v-list>
              <v-list-item
                two-line
                v-for="usePayment in (item.usePayments || [])" :key="usePayment"
                link
                @click="openPaymentById(usePayment)"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    Payment
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Click to open
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-progress-circular
                    v-if="$store.getters.isLoadingFor(`payments_${usePayment}.read`)"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </div>
      </div>
    </template>

    <v-dialog :value="!!selectedPayment" @input="closePayment" max-width="600px" scrollable>
      <v-card>
        <v-card-title>
          Order details
          <div class="d-inline-block ml-4">
            <div
              v-if="(selectedPayment || {}).transactionType == 'REFUND'"
              class="d-flex flex-row align-center red--text text--darken-1"
            >
              <span>Refund</span>
              <v-icon class="ml-2 red--text text--darken-1">mdi-cash-refund</v-icon>
            </div>
            <div v-else
              class="d-flex flex-row align-center green--text text--darken-1"
            >
              <span>Purchase</span>
              <v-icon class="ml-2 green--text text--darken-1">mdi-basket</v-icon>
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <payment :item="selectedPayment" @open-payment="openPaymentById"/>
        </v-card-text>

        <v-divider/>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click="closePayment">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {DateTimeInputAlt} from 'dync-datetime';
import InfoTable from '../components/InfoTable.vue';
import Payment from '../components/Payment.vue';

export default {
  name: 'DiscountForm',
  components: {
    DateTimeInputAlt,
    InfoTable,
    Payment
  },
  props: {
    item: {},
    creating: {
      type: Boolean
    },
    state: {},
    required: {}
  },
  data() {
    return {
      headers: [
        {
          text: 'Number of uses',
          value: 'usePayments',
          morph: (v) => (v || []).length + ((v || []).length == 1 ? ' use' : ' uses')
        },
        {
          text: 'Created at',
          value: 'created_at',
          morph: (v) => (v || '').slice(0, 16)
        },
        {
          text: 'Created by',
          value: 'created_by'
        }
      ],
      showCode: false,
      discountTypes: [
        {
          text: 'Percentage discount on total purchase',
          value: 'total_percentage'
        }
      ],
      selectedPayment: null
    };
  },
  watch: {
    item () {
      this.showCode = false;
    }
  },
  methods: {
    openPaymentById (paymentId) {
      var payment = this.$store.getters['payments/getItemById'](paymentId);
      if (payment) {
        // Close previous to visulize change of payment object
        this.selectedPayment = null;
        setTimeout(() => {
          this.selectedPayment = payment;
        }, 250);
        return;
      }
      var promise = this.$store.dispatch('payments/fetchItemById', paymentId).then(() => {
        this.selectedPayment = this.$store.getters['payments/getItemById'](paymentId);
      }, () => {
        this.$snackbar({message: 'Failed to fetch payment', theme: 'error'});
      });
      this.selectedPayment = null;
      return promise;
    },
    closePayment () {
      this.selectedPayment = null;
    }
  }
}
</script>

<style lang="css" scoped>
</style>
